<script>
import { mapActions, mapState } from 'vuex';
import mainViewTabMixin from '../../mixins/mainViewTab';
import paginationMixin from '../../mixins/pagination';
import BlogEntryListItem from './components/BlogEntryListItem';

export default {
  name: 'BlogEntryList',
  components: {
    BlogEntryListItem,
  },
  mixins: [mainViewTabMixin, paginationMixin],
  data() {
    return {
      isInitialized: false,
      headers: [{ text: 'Titel', value: 'headline' }, { text: 'Aktionen', value: '' }],
    };
  },
  computed: {
    ...mapState(['blogEntryList']),
    ...mapState('blogEntryList', ['meta']),
  },
  mounted() {
    this.fetchData(this.paginationParams)
      .then(() => {
        this.isInitialized = true;
      });
  },
  methods: {
    ...mapActions('blogEntryList', { fetchData: 'fetchBlogEntryList' }),
    ...mapActions('blogEntryDetails', ['deleteBlogEntry']),
    onDelete() {
      this.fetchData(this.paginationParams).then(() => {
        this.isInitialized = true;
      });
    },
    onRefresh() {
      this.fetchData(this.paginationParams).then(() => {
        this.isInitialized = true;
      });
    },
    onNewBlogEntry() {
      this.$router.push('/blogEntryDetails');
    },
  },
};
</script>

<template>
  <div>
    <v-toolbar dark dense height="40" color="blue-grey lighten-2">
      <v-tooltip bottom>
        <v-btn @click="onNewBlogEntry" icon slot="activator">
          <v-icon>add</v-icon>
        </v-btn>
        <span>Neu</span>
      </v-tooltip>

      <v-tooltip bottom>
        <v-btn @click="onRefresh" icon slot="activator">
          <v-icon>refresh</v-icon>
        </v-btn>
        <span>Aktualisieren</span>
      </v-tooltip>
    </v-toolbar>

    <v-data-table
      :headers="headers"
      :items="blogEntryList.data"
      :disable-initial-sort="true"
      :pagination="pagination"
      :loading="blogEntryList.isLoading"
      :rows-per-page-items="rowsPerPageItems"
      :total-items="pagination.totalItems"
      :expand="true"
      item-key="id"
      @update:pagination="loadNextPage"
      rows-per-page-text="Zeilen pro Seite"
      no-data-text="keine Daten verfügbar"
      class="elevation-1 js-table"
    >
      <template slot="items" slot-scope="props">
        <blogEntry-list-item
          :blog-entry="props.item"
          :expanded="props.expanded"
          @delete="onDelete"
        />
      </template>

      <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        von {{ pageStart }} bis {{ pageStop }}
      </template>
    </v-data-table>
  </div>
</template>
